<template>
    <v-data-iterator
      :items="items"
      content-tag="v-layout"  
      hide-actions >  <!-- "v-layout" helps in displaying data in row format,
                       Hide action helps in not dsiplaying Pagination -->

      <template slot="header">
        <v-toolbar class="mb-2" color="primary" dark  flat>
          <v-toolbar-title>Firms Sheet</v-toolbar-title>
        </v-toolbar>
      </template>
      
      <template slot="item" slot-scope="props">
        <v-flex xs12 sm6 md4 lg3>
          <v-card>
            <v-card-title class="primary white--text">{{ props.item.name }}</v-card-title>
            <v-divider></v-divider>

            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>Expense Account:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.expaccount }}</v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>Asset Account:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.assetaccount }}</v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>Other Income Account:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.otherincomeaccount }}</v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>Item Account:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.itemaccount }}</v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>Interest Account:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.intaccount }}</v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>Buyer Account:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.custaccount }}</v-list-tile-content>
              </v-list-tile>

            </v-list>
          </v-card>
        </v-flex>
      </template>
    </v-data-iterator>
</template>
<script>
  export default {
    data: () => ({
      items: [
        {
          name: 'Firm 1',
          expaccount: 100000,
          assetaccount: 5000000,
          otherincomeaccount:150000,
          itemaccount: 519,
          intaccount: 1500000,
          custaccount: 789
        },
        {
          name: 'Firm 2',
          expaccount: 100000,
          assetaccount: 5000000,
          otherincomeaccount:150000,
          itemaccount: 519,
          intaccount: 1500000,
          custaccount: 789
        },
        {
          name: 'Firm 3',
          expaccount: 100000,
          assetaccount: 5000000,
          otherincomeaccount:150000,
          itemaccount: 519,
          intaccount: 1500000,
          custaccount: 789
        },
        {
          name: 'Firm 4',
          expaccount: 100000,
          assetaccount: 5000000,
          otherincomeaccount:150000,
          itemaccount: 519,
          intaccount: 1500000,
          custaccount: 789
        }
      ]
    })
  }
</script>



// WEBPACK FOOTER //
// src/components/Informations/Firmsheet/index.vue